import type { Id } from "../../../lib/Id";
import { put } from "../../request";

const unmute = (id: Id): Promise<Record<string, never>> =>
  put(`/api/listings/${id}/unmute`);

export default unmute;
